(() => {
  if (window.drvProductVideoVisibility) return;
  window.drvProductVideoVisibility = true;
  const observed = new Set();
  const resume = new WeakSet();
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const visible = video => {
    const rect = video.getBoundingClientRect();
    return !document.hidden && rect.width > 0 && rect.height > 0 && rect.bottom > 0 && rect.top < innerHeight && rect.right > 0 && rect.left < innerWidth;
  };
  const stop = video => {
    if (!video.paused) {
      resume.add(video);
      const player = video.closest('video-media');
      if (player?.pause) player.pause();
      video.pause();
    }
  };
  const sync = video => {
    if (!video.isConnected) { observer.unobserve(video); observed.delete(video); return; }
    if (!visible(video) || reduced.matches) { stop(video); return; }
    if (resume.has(video)) {
      resume.delete(video);
      const player = video.closest('video-media');
      if (player?.play) player.play();
      else video.play().catch(() => {});
    }
  };
  const observer = new IntersectionObserver(entries => entries.forEach(entry => sync(entry.target)), { threshold: [0, 0.01] });
  const scan = () => {
    document.querySelectorAll('#MainContent video').forEach(video => {
      if (observed.has(video)) return;
      observed.add(video);
      observer.observe(video);
      video.addEventListener('play', () => {
        if (!visible(video)) stop(video);
      });
      sync(video);
    });
    observed.forEach(video => { if (!video.isConnected) { observer.unobserve(video); observed.delete(video); } });
  };
  const all = () => observed.forEach(sync);
  document.addEventListener('visibilitychange', all);
  window.addEventListener('resize', all, { passive: true });
  reduced.addEventListener('change', all);
  const main = document.getElementById('MainContent');
  if (!main) return;
  new MutationObserver(scan).observe(main, { childList: true, subtree: true });
  scan();
})();
